export const messages = {
    "wr-dashboard.search.input.hint": "Recherche",
    "wr-dashboard.search.label.breadcrumb": "Résultats de la recherche",
    "wr-dashboard.search.message.empty": "Aucun élément ne correspond à votre recherche",
    "wr-dashboard.side-bar.selected.title:plural": "{count} éléments sélectionnés | {count} élément sélectionné | {count} éléments sélectionnés",
    "wr-dashboard.side-bar.backup-type.disk": "Disque",
    "wr-dashboard.side-bar.backup-type.file": "Fichier",
    "wr-dashboard.side-bar.backup-type.notarized": "Fichiers et dossiers notariés",
    "wr-dashboard.side-bar.backup-type.exchange": "Application - Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Application - Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Application - État du système",
    "wr-dashboard.side-bar.backup-type.application": "Application",
    "wr-dashboard.backups-table.column.name": "Nom",
    "wr-dashboard.backups-table.column.size": "Taille",
    "wr-dashboard.backups-table.column.version": "Dernière version",
    "wr-dashboard.backups-table.action.delete": "Supprimer",
    "wr-dashboard.backups-table.message.no-backups": "Il n'existe encore aucune sauvegarde dans le Cloud",
    "wr-dashboard.backups-sidebar.label.size": "Taille",
    "wr-dashboard.backups-sidebar.label.type": "Type",
    "wr-dashboard.backups-sidebar.label.version": "Dernière version",
    "wr-dashboard.backups-sidebar.label.created": "Créé",
    "wr-dashboard.backups-sidebar.label.machine": "Machine",
    "wr-dashboard.backups-sidebar.label.owner": "Propriétaire",
    "wr-dashboard.content-table.column.name": "Nom",
    "wr-dashboard.content-table.column.versions": "Versions",
    "wr-dashboard.content-table.column.volumes": "Volumes",
    "wr-dashboard.content-table.column.path": "Chemin d'accès",
    "wr-dashboard.content-table.column.size": "Taille",
    "wr-dashboard.content-table.column.version": "Dernière version",
    "wr-dashboard.content-table.action.notary-verify": "Vérifier",
    "wr-dashboard.content-table.action.notary-get-crt": "Obtenir certificat",
    "wr-dashboard.content-table.action.asign": "Envoyer pour signature",
    "wr-dashboard.content-table.action.versions": "Versions",
    "wr-dashboard.content-table.action.restore": "Télécharger",
    "wr-dashboard.content-table.label.size": "Taille",
    "wr-dashboard.content-table.label.created": "Créé",
    "wr-dashboard.content-table.label.modified": "Modifié",
    "wr-dashboard.content-table.message.empty-folder": "Ce dossier est vide",
    "wr-dashboard.password-dialog-box.title.backup": "Sauvegarde chiffrée",
    "wr-dashboard.password-dialog-box.title.archive": "Archive chiffrée",
    "wr-dashboard.password-dialog-box.message.backup": "Veuillez indiquer le mot de passe pour accéder à la sauvegarde {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Veuillez indiquer le mot de passe pour accéder à l'archive {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Mot de passe",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Mot de passe incorrect",
    "wr-dashboard.form.button.open": "Ouvrir",
    "wr-dashboard.form.button.close": "Fermer",
    "wr-dashboard.form.button.cancel": "Annuler",
    "wr-dashboard.form.button.continue": "Continuer",
    "wr-dashboard.form.button.proceed": "Poursuivre",
    "wr-dashboard.form.button.delete": "Supprimer",
    "wr-dashboard.form.button.done": "Terminé",
    "wr-dashboard.form.button.retry": "Réessayer",
    "wr-dashboard.notary.verify.view.status.downloading": "Téléchargement en cours...",
    "wr-dashboard.notary.verify.view.status.validating": "Validation en cours...",
    "wr-dashboard.notary.verify.view.status.pending": "Certificat en attente…",
    "wr-dashboard.notary.verify.view.status.fail": "Les certificats ne correspondent pas...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Obtenir certificat",
    "wr-dashboard.notary.verify.view.file-info.name": "NOM",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "SIGNÉ PAR",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "DATE DE LA SAUVEGARDE",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "DATE DE LA NOTARISATION",
    "wr-dashboard.notary.verify.view.button.cancel": "Annuler",
    "wr-dashboard.notary.verify.view.button.done": "Terminé",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Version de navigateur non prise en charge",
    "wr-dashboard.versions-dialog-box.title": "Versions de {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Envoyer pour signature",
    "wr-dashboard.asign-dialog-box.message": "La version de fichier est partagée, mais personne ne peut consulter le fichier sans le lien qui y mène.Passer à ASign pour ajouter des signataires et partager le lien.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Afficher les détails du fichier",
    "wr-dashboard.page-not-found.title": "Page introuvable",
    "wr-dashboard.page-not-found.message.main": "La page que vous cherchiez est introuvable.",
    "wr-dashboard.page-not-found.message.description": "Il se peut que le lien soit obsolète ou que vous ayez mal saisi l'adresse.",
    "wr-dashboard.page-not-found.message.error": "Code d'erreur : 404",
    "wr-dashboard.server-error.title": "Le serveur n'est pas disponible",
    "wr-dashboard.server-error.message": "Le serveur n'est pas disponible pour le moment. Veuillez réessayer plus tard.",
    "wr-dashboard.server-error.message.error": "Code d'erreur : 500",
    "wr-dashboard.account-menu.action.sign-out": "Déconnexion",
    "wr-dashboard.breadcrumb.item.machines": "Machines",
    "wr-dashboard.breadcrumb.item.failed-backups": "Sauvegardes échouées",
    "wr-dashboard.machines-table.column.name": "Nom",
    "wr-dashboard.machines-table.column.size": "Taille",
    "wr-dashboard.machines-table.message.no-machines": "Il n'existe pas encore de machine dans le Cloud",
    "wr-dashboard.incomplete-backups.message.status:plural": "Vous avez {count} sauvegardes échouées ou incomplètes qui occupent {size} de votre espace de stockage | Vous avez {count} sauvegarde échouée ou incomplète qui occupe {size} de votre espace de stockage | Vous avez {count} sauvegardes échouées ou incomplètes qui occupent {size} de votre espace de stockage",
    "wr-dashboard.incomplete-backups.button.view": "Afficher les sauvegardes",
    "wr-dashboard.incomplete-backups.button.delete": "Supprimer les sauvegardes",
    "wr-dashboard.machines-table.message.space-used:plural": "Utilisation totale de sauvegarde {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Supprimer les archives",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Supprimer des archives incomplètes",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Supprimer toutes les archives incomplètes",
    "wr-dashboard.delete-archive.message": "Voulez-vous vraiment supprimer définitivement les archives sélectionnées de tous les emplacements ? Les données seront supprimées et ne pourront pas être restaurées.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Le certificat est en attente",
    "wr-dashboard.certificate-pending-dialog-box.message": "Réessayez dans quelques minutes.",
    "wr-dashboard.form.button.ok": "Ok"
};
